var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Nuxt'),_vm._v(" "),_c('ModalV2'),_vm._v(" "),_c('fab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }